// extracted by css-extract-rspack-plugin
export default {"snackbarContainer":"product-detail-fragment__NotificationSnackbar_snackbarContainer__7mrXL","slide-up":"product-detail-fragment__NotificationSnackbar_slide-up__XuGiE"};